import _ from 'lodash';

const namespaced = true;

const state = {
  interventionId: null,
  intervention: {},
  statuses: [],
  users: [],
};

const mutations = {
  SET_INTERVENTION_ID(state, interventionId) {
    state.interventionId = interventionId;
  },
  SET_INTERVENTION(state, intervention) {
    state.intervention = intervention;
  },
  SET_STATUSES(state, statuses) {
    state.statuses = statuses;
  },
  SET_USERS(state, users) {
    state.users = users;
  },
};

const actions = {
  async fetchIntervention({ commit, dispatch, state }) {
    if (!state.interventionId) { return Promise.resolve(); }

    const intervention = await dispatch(`model/intervention/fetchOne`, state.interventionId, { root: true });
    commit(`SET_INTERVENTION`, intervention);

    return intervention;
  },
  async fetchStatuses({ commit, dispatch, state }) {
    const statuses = await dispatch(`model/status/fetchListForMaker`, state.intervention.Maker_id, { root: true });
    commit(`SET_STATUSES`, statuses);

    return statuses;
  },
  async fetchUsers({ commit, dispatch, state }) {
    const users = await dispatch(`model/user/fetchForClient`, state.intervention.Maker_id, { root: true });
    commit(`SET_USERS`, users);

    return users;
  },
  async createReport({ dispatch, state }, report) {
    const createdReport = await dispatch(`model/interventionReport/create`, {
      ...report,
      Intervention_id: state.interventionId,
    }, { root: true });

    return createdReport;
  },
};

const getters = {
  intervention: state => {
    const intervention = {
      ...state.intervention,
    };

    if (intervention.id) {
      const { site } = intervention;
      intervention.$sitePostalCodeAndCity = _.trim(`${site.postalCode || ``} ${site.city || ``}`);
      intervention.$htmlDescription = intervention.description.replace(/\r\n|\r|\n/g, `<br />`);
    }

    return intervention;
  },
  statuses: state => state.statuses,
  users: state =>
    _.chain(state.users)
      .filter(user => !user.isExcludedFromPlanning)
      .map(user => ({
        ...user,
        name: `${user.firstname} ${user.lastname}`,
      }))
      .value()
  ,
};

export default {
  namespaced, state, mutations, actions, getters,
};
